angular
    .module('mediaTagManagerModule')
    .directive('file', ['modalDialog', function(modalDialog) {
        return {
            scope: {
                file: '=',
            },
            link: function(scope, el, attrs) {
                el.bind('change', function(event) {
                    var file = event.target.files;
                    if (file[0].name.indexOf('.xls') === -1 && file[0].name.indexOf('.xlsx') === -1) {
                        modalDialog.alertType('非法的文件格式，必须为xls或xlsx类型', '', 'error', false);
                        return;
                    }
                    scope.file = file ? file : undefined;
                    scope.$apply();
                });
            },
        };
    }])
    .controller('importMediaTagCtrl', [
        '$scope',
        '$q',
        'trsHttpService',
        '$modalInstance',
        '$validation',
        'mediaTagApiService',
        'options',
        function($scope, $q, trsHttpService, $modalInstance, $validation, mediaTagApiService, options) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             *
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.status = {
                    file: null,
                    scope: 'public',
                };
                $scope.importUrl = trsHttpService.getMRURL() + '/meizi/label/import';
                $scope.data = {};
                $scope.fileName = '';
                $scope.downloadUrl = options.type === 'person' ? '/bigscreen/label_template/personTemplate.xls' : '/bigscreen/label_template/eventTemplate.xls';
            }

            /**
             * [initData description] 初始化数据
             *
             * @return  {[type]}  [return description]
             */
            function initData() {}

            /**
             *[close description] 取消按钮操作
             * @return  {[type]}  [return description]
             */
            $scope.close = function() {
                $modalInstance.dismiss();
            };

            $scope.import = function(){
                document.getElementById('tagImportInput').click();
            };

            /**
             * [confirm description] 确定按钮
             *
             * @return  {[type]}  [return description]
             */
            $scope.confirm = function() {
                let params = {
                    scope: $scope.status.scope,
                    file: $scope.upload_file[0],
                    type: options.type
                };
                $scope.loadingPromise = mediaTagApiService.importTags(params).then(function(data) {
                    $modalInstance.close(data);
                });
            };
        },
    ]);
